/** tools group: HS classifier, duty estimator, tracking, documents, RFQ + space offers (docs/03 "Vocabulary"). A WP adds to its own group and to docs/03 in the same commit. */
export const toolsPermissions = [
  'hs:classify',
  'duty:estimate',
  'tracking:manage',
  'document:render',
  'document:sign',
  'rfq:post',
  'rfq:respond',
  'rfq:award',
  'offer:post',
  'offer:respond',
] as const;

export type ToolsPermission = (typeof toolsPermissions)[number];
